// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
}

.topBgBlock {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    height: 53px;
    display: flex;
    align-items: left;
    justify-content: left;
    padding: 30px 0 0 16px;
}

.topBgArrow {
    width: 26px;
    height: 22.45px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Common/Common.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".topBg {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 0;\n}\n\n.topBgBlock {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n    height: 53px;\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    padding: 30px 0 0 16px;\n}\n\n.topBgArrow {\n    width: 26px;\n    height: 22.45px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
